<template>
  <a-layout-sider
    :class="['sider', isDesktop() ? null : 'shadow', theme, fixSiderbar ? 'ant-fixed-sidemenu' : null ]"
    width="180px"
    :collapsible="collapsible"
    v-model="collapsed"
    :trigger="null">
    <logo/>
    <div style="padding-top: 50px;height: calc(100% - 0px)" v-bar>
      <div>
        <div style="">
          <user-logo/>
          <s-menu
            :collapsed="collapsed"
            :menu="menus"
            :theme="theme"
            :mode="mode"
            @select="onSelect"
            style="padding: 16px 0px;margin: 0 5px;"></s-menu>
        </div>

      </div>

    </div>

  </a-layout-sider>

</template>

<script>
  import Logo from '@/components/tools/Logo'
  import UserLogo from '@/components/tools/UserLogo'
  import SMenu from './index'
  import { mixin, mixinDevice } from '@/utils/mixin'
  import {mapState} from "vuex";

  export default {
    name: 'SideMenu',
    components: { Logo, UserLogo, SMenu },
    mixins: [mixin, mixinDevice],
    props: {
      mode: {
        type: String,
        required: false,
        default: 'inline'
      },
      theme: {
        type: String,
        required: false,
        default: 'dark'
      },
      collapsible: {
        type: Boolean,
        required: false,
        default: false
      },
      collapsed: {
        type: Boolean,
        required: false,
        default: false
      },
      menus: {
        type: Array,
        required: true
      }
    },
    computed:{
      ...mapState({
        // 动态主路由
        flushIndex: state => state.permission.flushIndex
      }),
    },
    watch:{
      flushIndex(oldValue,newValue){
        console.log("刷新左边菜单数据-=====")
        console.log(this.menus)
        this.$forceUpdate();
      }
    },
    methods: {
      onSelect(obj) {
        this.$emit('menuSelect', obj)
      }
    }
  }
</script>
